import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/shared/uikit/Button";
import { Form } from "@/react/components/shared/uikit/Form";
import type { BrandingSettings } from "../PlusLiteDashboard";
import { BrandingSettingsFormContent } from "./BrandingSettingsFormContent";

export const BrandingSettingsForm = ({
  defaultValues,
  handleSubmit,
  isSaving,
}: {
  defaultValues: BrandingSettings;
  handleSubmit: (brandingSettings: BrandingSettings) => void;
  isSaving: boolean;
}) => (
  <Form onSubmit={handleSubmit} defaultValues={defaultValues}>
    <BrandingSettingsFormContent />
    <div className="mt-6 flex justify-end">
      <Button type="submit" variant="circle" disabled={isSaving}>
        {isSaving ? t("saving") : t("save_changes")}
      </Button>
    </div>
  </Form>
);
